import { render, staticRenderFns } from "./ListFeeTypes.vue?vue&type=template&id=253610ee&scoped=true"
import script from "./ListFeeTypes.vue?vue&type=script&lang=js"
export * from "./ListFeeTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253610ee",
  null
  
)

export default component.exports